var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgF410F5F4E93B55064Cff5D0Fc479225B(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.473,
    height: 36,
    viewBox: "0 0 30.473 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "f410f5f4e93b55064cff5d0fc479225b",
    d: "M15.888,16.18A2.223,2.223,0,0,0,13.666,18.4l0,9.3a2.222,2.222,0,1,0,4.444,0V18.4a2.223,2.223,0,0,0-2.224-2.221M33.806,7.825l1.551-2.832a.308.308,0,1,0-.54-.3L33.25,7.558a10.827,10.827,0,0,0-8.7,0L22.984,4.7a.307.307,0,1,0-.539.295L24,7.824a9.074,9.074,0,0,0-5.106,8l20.014,0a9.079,9.079,0,0,0-5.1-8M24.344,12.2a.839.839,0,1,1,.841-.839.839.839,0,0,1-.841.839m9.113,0a.84.84,0,1,1,.838-.838.838.838,0,0,1-.838.838M18.972,16.6l0,14.419a2.368,2.368,0,0,0,2.371,2.37h1.614l0,4.923a2.222,2.222,0,1,0,4.443,0V33.39h3v4.923a2.222,2.222,0,1,0,4.444,0l0-4.922h1.62a2.372,2.372,0,0,0,2.372-2.371l0-14.419-19.865,0Zm25.165,1.8a2.222,2.222,0,1,0-4.443,0l0,9.3a2.221,2.221,0,1,0,4.443,0l0-9.3Z",
    transform: "translate(-13.666 -4.536)",
    fill: "#a4c439"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgF410F5F4E93B55064Cff5D0Fc479225B);
export default __webpack_public_path__ + "static/media/f410f5f4e93b55064cff5d0fc479225b.c8863a54cbb2ea7a46e357bf67933004.svg";
export { ForwardRef as ReactComponent };